module.exports = __webpack_public_path__ + "components/wind-icon/static/SSW@2x-95a7a793c44081565c895e9ac04f9c6b.png";